import { useAppDispatch, useAppSelector } from "@/store"
import { selectCursorStyle } from "@/stores/mouse_slice"
import { Box } from "@chakra-ui/react"
import React, { useMemo, useRef } from "react"
import { useFullScreen } from "./full_screen"
import { CanvasRemoteCursor, CssRemoteCursor } from "./remote_cursor"
import { RemoteDeskView } from "./remote_desk"
import { ExitRemoteDeskModal, SettingEntry } from "./setting_entry"
import { FileTransferList, FileTransferType } from "./transfer_file_list"
import { ConnStateNotifier } from "./conn_state_notifier"
import { useFixFullScreenCursorStyle } from "@/hooks/use_fix_fullscreen_cursor"
import { useAutoLogout } from "@/hooks/auto_logout"
import { useAutoLogoutAudio } from "@/hooks/auto_logout_Audio"
import { ConnectionUseCase } from "@/usecases/connection"
import { LoginStatus, updateLoginStatus } from "@/stores/login_slice"
import { selectIsChromiumBlinkBrowser } from "@/stores/app_slice"
import {
  selectAutoLogoutTimeGap,
  selectIsFullScreen,
} from "@/stores/remote_desk_state_slice"
import { getOS, OS } from "@/utils/os"
import { mytest } from "@/utils/tools"

const RemoteDeskPage: React.FC = () => {
  const dispatch = useAppDispatch()
  // 系统鼠标指针样式
  const sysCursor = useAppSelector(selectCursorStyle)
  // console.log("[RemoteDeskPage] 系统鼠标指针样式:", sysCursor)

  const isFullScreen = useAppSelector(selectIsFullScreen)
  const isChromiumBlinkVal = useAppSelector(selectIsChromiumBlinkBrowser)

  const remoteDeskRef = useRef<HTMLDivElement>(null)
  useFullScreen(remoteDeskRef)
  useFixFullScreenCursorStyle(remoteDeskRef)

  // 自动退出
  const autoLogoutTimeGap = useAppSelector(selectAutoLogoutTimeGap)

  const timeGapNum = useMemo(() => {
    switch (autoLogoutTimeGap) {
      case "five_minutes":
        return 5 * 60 * 1000 // 5分钟

      case "ten_minutes":
        return 10 * 60 * 1000 // 10分钟

      case "thirty_minutes":
        return 30 * 60 * 1000 // 30分钟

      case "one_hour":
        return 60 * 60 * 1000 // 60分钟（1小时）

      case "time_never":
        return 365 * 24 * 60 * 60 * 1000 // 1年

      default:
        return 30 * 60 * 1000 // 30分钟
    }
  }, [autoLogoutTimeGap])

  // 播放视频
  const isAutoLogoutAudio = useAutoLogoutAudio(timeGapNum)
  const isAutoLogout = useAutoLogout(timeGapNum)

  if (isAutoLogoutAudio && isAutoLogout) {
    ConnectionUseCase.exitRemoteDesk()
    dispatch(
      updateLoginStatus({
        msg: `检测到您已  ${timeGapNum / 1000 / 60}分钟  未操作云电脑，已自动退出`,
        status: LoginStatus.error,
      })
    )
  }

  const isMac = getOS() === OS.MacOS
  return (
    <Box
      ref={remoteDeskRef}
      width="100vw"
      height="100vh"
      position="relative"
      backgroundColor="black"
      overflow="hidden"
      style={{ cursor: sysCursor }}
    >
      {/* 云桌面 */}
      <RemoteDeskView />

      {/* 设置弹窗入口 */}
      <SettingEntry />

      {/* 远程光标事件处理（设置 CSS cursor 样式） */}
      {isFullScreen && isMac && mytest && isChromiumBlinkVal ? (
        <CanvasRemoteCursor />
      ) : (
        <CssRemoteCursor />
      )}
      {/* <RemoteCursor /> */}

      {/* 文件传输列表 */}
      <FileTransferList type={FileTransferType.Recv} />
      {/* 文件上传列表 */}
      <FileTransferList type={FileTransferType.Send} right={10} bottom={10} />
      {/* "退出云桌面" 确认弹窗 */}
      <ExitRemoteDeskModal />
      {/* 连接状态提示，用于提示重连时的状态变更 */}
      <ConnStateNotifier />
    </Box>
  )
}

export default RemoteDeskPage
